import { render, staticRenderFns } from "./ProductSelect.vue?vue&type=template&id=b8600db2&scoped=true&"
import script from "./ProductSelect.vue?vue&type=script&lang=js&"
export * from "./ProductSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8600db2",
  null
  
)

export default component.exports